<li tabindex="14">
    <ng-select
        class="nlr-ng-select nlr-ng-select-ribbon"
        [searchable]="false"
        [clearable]="false"
        name="selectionMethod"
        id="selectionMethod"
        title="Select the feature selection method"
        [items]="selectionMethods"
        bindLabel="label"
        [(ngModel)]="selectionMethod"
        (change)="selectionMethodChange()">
    </ng-select>
</li>
<li tabindex="15">
    <ng-select
        class="nlr-ng-select nlr-ng-select-ribbon nlrp-features-dropdown"
        [searchable]="false"
        [clearable]="false"
        name="featureClassSelectionMethod"
        id="featureClassSelectionMethod"
        title="Select the feature types to be included in the selection"
        [items]="featureClassSelectionMethods"
        bindLabel="description"
        [(ngModel)]="featureClassSelectionMethod"
        (change)="featureClassSelectionMethodChange()"
        dropdownPosition="bottom">
        <ng-template ng-option-tmp let-item="item">
            <div [title]="item.tooltip">
                <i class="nlrp-icon">{{item.icon}}</i>
                {{item.description}}
            </div>
        </ng-template>
    </ng-select>
</li>
